<template lang="pug">
  #team-center
    router-view
</template>

<script>
export default {
  name: "TeamCenter"
};
</script>

<style lang="sass" scoped></style>
